import {LinkButton} from '@superweb/ui'
import {useI18n} from '@yandex-delivery/core/i18n'
import {Typography} from '@yandex-delivery/ui'

import {Paper} from '../../../../components/ui'
import {useConfig} from '../../../../config'
import styleClasses from './classes@desktop.module.css'

export function ExactPriceBlock() {
  const {pathToCreateOrder} = useConfig()
  const i18n = useI18n()

  return (
    <Paper
      className={styleClasses.exactPriceBlock}
      title={i18n('tariffs-v3.exact-price-block.title', 'Узнайте точную стоимость в форме заказа')}
    >
      <div className={styleClasses.exactPriceBlockContent}>
        <Typography density="tight" level="body2" weight="regular">
          {i18n(
            'tariffs-v3.exact-price-block.text',
            'Она поможет учесть все детали: точные адреса, платные опции и подходящий вам способ оплаты',
          )}
        </Typography>
        <LinkButton
          link={{href: pathToCreateOrder}}
          text={i18n('tariffs-v3.exact-price-block.button', 'Перейти к форме')}
          view="action"
        />
      </div>
    </Paper>
  )
}
